export default "__VITE_ASSET__CgZgYb5i__"